"use client";

import StoryContent from "../../elements/story/StoryContent";
import StoriesSwiper from "../../elements/swipers/StoriesSwiper";
import { HomeStory } from "@/app/lib/features/home/home.types";
import { useTrackView } from "@/app/hooks/useTrackView";

interface StoriesSectionProps {
  stories: HomeStory[];
  sectionId?: number | string;
}

const StoriesSection = ({ stories, sectionId }: StoriesSectionProps) => {
  const trackRef = useTrackView("stories", sectionId);

  if (!stories || stories.length === 0) return <></>;

  return (
    <div ref={trackRef} className="overflow-x-clip">
      <StoriesSwiper stories={stories} />
      <StoryContent />
    </div>
  );
};

export default StoriesSection;
